(() => {
  const placeTryOn = () => {
    if (!document.body.classList.contains('goat-template-product')) return true;

    const button = document.querySelector('button[id^="tryon-btn-"]');
    if (!button) return false;

    const appSection = button.closest('.shopify-section');
    if (!appSection) return false;
    if (appSection.classList.contains('goat-tryon-placement')) return true;

    const productDetails = Array.from(document.querySelectorAll('.product-container .product-details'))
      .find((element) => {
        const rect = element.getBoundingClientRect();
        const styles = window.getComputedStyle(element);
        return rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
      });

    if (!productDetails) return false;

    const buyForm = Array.from(productDetails.querySelectorAll('form'))
      .find((form) => form.querySelector('button')?.textContent.trim() === 'Buy Now');

    if (buyForm) productDetails.insertBefore(appSection, buyForm);
    else productDetails.appendChild(appSection);

    appSection.classList.add('goat-tryon-placement');

    const pageWidth = appSection.querySelector('.page-width');
    if (pageWidth && !appSection.querySelector('.goat-tryon-invite')) {
      const invitation = document.createElement('div');
      invitation.className = 'goat-tryon-invite';
      invitation.innerHTML = `
        <p>Private AI fitting room</p>
        <h2>See it on you.</h2>
        <span>One clear photo. A personal preview before you decide.</span>
      `;
      appSection.insertBefore(invitation, pageWidth);
    }

    const buttonLabel = button.querySelector('span');
    if (buttonLabel) buttonLabel.textContent = 'Create my private try-on';
    button.setAttribute('aria-label', 'Create my private virtual try-on');

    const helper = appSection.querySelector('[class^="tryon-helper-text-"]');
    if (helper) helper.textContent = 'Free preview · No purchase required · Your photo stays private';

    return true;
  };

  const initialise = () => {
    if (placeTryOn()) return;

    const observer = new MutationObserver(() => {
      if (placeTryOn()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
